module.exports = __webpack_public_path__ + "img/case1.1b6ef3e8.png";